<template>
  <b-card no-body>
    <b-card-body>
      <b-row>
        <b-col>
          <b-input-group>
            <b-form-input
              v-model="search"
              placeholder="Teklif Ara"
              @keydown.enter="searchData"
            />
            <b-input-group-append>
              <b-button
                v-if="search !== ''"
                variant="warning"
                @click="resetSearch"
              ><FeatherIcon icon="XIcon" /></b-button>
              <b-button
                variant="primary"
                :disabled="search === ''"
                @click="searchData"
              ><FeatherIcon icon="SearchIcon" /></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col
          cols="12"
          md="auto"
        >
          <b-button
            to="offers/add"
            variant="primary"
            block
          >
            <FeatherIcon icon="PlusIcon" />
            Oluştur
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
    >
      <template #cell(onum)="data">
        {{ data.item.onum }}
        <span
          v-if="data.item.onum_rno"
          class="text-danger"
        >
          R{{ data.item.onum_rno }}
        </span>
      </template>
      <template #cell(name)="data">
        <div class="font-weight-bold">
          {{ data.item.company }}
        </div>
        <div class="text-primary">
          {{ data.item.title }}
        </div>
        <div
          v-if="data.item.name"
          class="text-muted font-small-3"
        >
          {{ data.item.name }}
        </div>
      </template>
      <template #cell(offer_status)="data">
        <b-badge
          :variant="data.item.status_variant"
          class="mb-1 w-100"
        >
          {{ data.item.offer_status }}
        </b-badge>
        <b-badge
          variant="light-warning"
          class="w-100"
        >
          {{ data.item.username }}
        </b-badge>
      </template>
      <template #cell(control)="data">
        <list-dropdown-buttons
          :primary-action="$route.path + '/view/' + data.item.id"
          primary-text="Görüntüle"
          :data-id="data.item.id"
          :delete-action="removeData"
          :edit-action="$route.path + '/edit/' + data.item.id"
          edit-text="Güncelle"
        />
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCount"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BRow, BCol, BTable, BCardFooter, BPagination, BButton, BFormInput, BInputGroup, BInputGroupAppend, BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ListDropdownButtons from '@/layouts/components/common/ListDropdownButtons.vue'

export default {
  name: 'Index',
  components: {
    ListDropdownButtons,
    BCard,
    BCardBody,
    BTable,
    BRow,
    BCol,
    BCardFooter,
    BPagination,
    BButton,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BBadge,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      currentPage: 1,
      perPage: 25,
      search: '',
      fields: [
        {
          key: 'onum',
          label: 'TEKLİF NO',
          thClass: 'width-50 text-nowrap',
          tdClass: 'width-50 text-nowrap',
        },
        {
          key: 'name',
          label: 'FİRMA ADI / İLGİLİ KİŞİ',
        },
        {
          key: 'offer_status',
          label: 'DURUM',
          thClass: 'width-50',
          tdClass: 'width-50',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-50 text-nowrap',
          tdClass: 'width-50 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          'offers.id AS id',
          'offers.onum AS onum',
          'offers.onum_rno AS onum_rno',
          'offers.title AS title',
          'offer_status.title AS offer_status',
          'offer_status.variant AS status_variant',
          'users.name AS username',
          'customers.company AS company',
          'offers.name AS name',
        ],
        limit: 25,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['offers/getOffers']
    },
    dataCount() {
      return this.$store.getters['offers/getOffersCount']
    },
    saveData() {
      return this.$store.getters['offers/getOfferSaveStatus']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 25
      this.pagination(page)
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
        this.getDataList()
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    searchData() {
      this.dataQuery.or_like = {
        'offers.onum': this.search,
        'offers.title': this.search,
        'customers.company': this.search,
      }
      this.getDataList()
    },
    resetSearch() {
      this.dataQuery.or_like = {}
      this.search = ''
      this.getDataList()
    },
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    removeData(id) {
      if (this.userData.id_user_types === '1') {
        this.$swal({
          title: this.$store.state.app.removeTitle,
          text: this.$store.state.app.removeMessage,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$store.state.app.removeConfirm,
          cancelButtonText: this.$store.state.app.removeCancel,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('offers/offerRemove', id)
            this.$swal({
              icon: 'success',
              title: this.$store.state.app.removeResultTitle,
              text: this.$store.state.app.removeResultMessage,
              confirmButtonText: this.$store.state.app.removeResultClose,
              customClass: {
                confirmButton: 'btn btn-success',
              },
            })
          }
        })
      } else {
        this.$swal({
          title: 'Yetki Sınırlaması!',
          text: 'Bu işlemi yapmak için yetkiniz bulunmuyor.',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: 'Kapat',
          customClass: {
            confirmButton: 'btn btn-success',
          },
          buttonsStyling: false,
        })
      }
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
    getDataList() {
      this.$store.dispatch('offers/offersList', this.dataQuery)
    },
  },
}
</script>
